"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetCustomerInfo = void 0;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
/**
 * Wrapper hook for retrieving Customer Type ID and Visitor Segment for authenticated customers only.
 * Provides loading and errors states.
 * Can be enabled from the outside to prevent fetching data.
 */
const useGetCustomerInfo = ({
  customerId,
  enabled: enabledFetch = true
}) => {
  const enabled = (0, _auth.isAuthenticatedCustomer)(customerId) && enabledFetch;
  const {
    data,
    error
  } = (0, _globalApiClientReact.useGetCustomerInfo)(customerId, undefined, {
    swr: {
      enabled,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  return (0, _react.useMemo)(() => ({
    consultantNumber: data?.consultantNumber,
    customerCategory: data?.customerType?.customerCategory,
    customerTypeId: data?.customerType?.customerTypeId,
    error,
    loading: enabled && data === undefined && error === undefined,
    visitorSegment: data?.visitorSegment
  }), [data, enabled, error]);
};
exports.useGetCustomerInfo = useGetCustomerInfo;
